import PlaygroundAuthType from "../../../playgroundAuthType";
import sanitizeName from "./sanitizeName";
import OAUTH_NOTE from "./oauthNote";

export const buildCursorDeeplink = (playground, bearerToken, mcpServerUrl) => {
  const config = {
    url: mcpServerUrl,
  };
  if (playground.authType === PlaygroundAuthType.BEARER_TOKEN) {
    config.headers = {
      Authorization: `Bearer ${bearerToken ? bearerToken : "<YOUR_API_KEY>"}`,
    };
  }
  const configString = JSON.stringify(config, null, 2);
  console.log("Cursor config: ", configString);
  const encodedConfig = btoa(configString);

  const link = `cursor://anysphere.cursor-deeplink/mcp/install?name=${sanitizeName(
    playground.name
  )}&config=${encodedConfig}`;
  console.log("Cursor deeplink: ", link);
  return link;
};

export const getCursorInstructions1 = (
  playground,
  bearerToken,
  mcpServerUrl
) => {
  let warning = "";
  if (!bearerToken && playground.authType === PlaygroundAuthType.BEARER_TOKEN) {
    warning = `

<strong>⚠️ Warning:</strong> This MCP server requires an API key. Please provide the API key above to be able to use the one-click installation.

`;
  }
  const oauthNote =
    playground.authType === PlaygroundAuthType.OAUTH ? OAUTH_NOTE : "";
  const result = `

${oauthNote}## One-click installation

Use the link below to add this server directly to your Cursor via the deeplink:${warning}

`;
  return result;
};

export const getCursorInstructions2 = (
  playground,
  bearerToken,
  mcpServerUrl
) => {
  let authInfo = "";
  if (playground.authType === PlaygroundAuthType.BEARER_TOKEN) {
    authInfo = `,
    "headers": {
      "Authorization": "Bearer ${bearerToken ? bearerToken : "<YOUR_API_KEY>"}"
    }`;
  }
  const result = `



## Using \`mcp.json\` 

To add an MCP server to your Cursor, you can create a \`mcp.json\` file in your project for project-specific tools.
Create \`~/.cursor/mcp.json\` in your home directory for tools available everywhere.

\`\`\`json
{
  "mcpServers": {
    "${sanitizeName(playground.name)}": {
      "url": "${mcpServerUrl}"${authInfo}
    }
  }
}
\`\`\`


For further details, see [the official documentation here](https://docs.cursor.com/context/mcp).


`;
  return result;
};
// install instructions https://docs.cursor.com/tools/developers
